import { DateTime } from 'luxon';

import type { ReservationFormValues } from '../../schema/reservationForm.schema';
import type { TripSegmentValues } from '../../schema/reservationForm.schema';

function isTripAddressFilled(
  address:
    | TripSegmentValues['pickupAddress']
    | TripSegmentValues['dropoffAddress'],
): boolean {
  if (typeof address === 'string') {
    return address.trim().length > 0;
  }
  if (address && typeof address === 'object') {
    if (address.isHeader === true || address.place_id === 'header') {
      return false;
    }
    return Boolean(
      address.place_id?.trim() ||
      address.mainText?.trim() ||
      address.description?.trim(),
    );
  }
  return false;
}

function tripLegMeetsDraftRequirements(trip: TripSegmentValues): boolean {
  if (!String(trip.reasonForTrip ?? '').trim()) {
    return false;
  }

  if (trip.isWillCall) {
    if (!String(trip.appointmentDate ?? '').trim()) {
      return false;
    }
  } else {
    const appt = trip.appointmentDateTime;
    if (appt == null || !(appt instanceof DateTime && appt.isValid)) {
      return false;
    }
  }

  if (!trip.isWillCall) {
    const pickup = trip.pickupDateTime;
    if (pickup == null || !(pickup instanceof DateTime && pickup.isValid)) {
      return false;
    }
  }

  if (!isTripAddressFilled(trip.pickupAddress)) {
    return false;
  }
  if (!isTripAddressFilled(trip.dropoffAddress)) {
    return false;
  }
  if (!String(trip.AttributeLevel1 ?? '').trim()) {
    return false;
  }
  if (!String(trip.MobilityAttribute ?? '').trim()) {
    return false;
  }

  return true;
}

function canSaveAsDraftFromFormValues(
  formValues: ReservationFormValues,
): boolean {
  if (!formValues.trips?.length) {
    return false;
  }
  return formValues.trips.every(tripLegMeetsDraftRequirements);
}

export { canSaveAsDraftFromFormValues };